import { Inject, Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map',
})
@Injectable({
  providedIn: 'root',
})
export class MapPipe implements PipeTransform {
  /**
   * Maps a numeric value from one range to another.
   *
   * If the input value is null or undefined, returns the minimum value of the target range.
   *
   * @param value - The input value to transform. If null or undefined, returns minTarget.
   * @param minValue - The minimum value of the source range.
   * @param maxValue - The maximum value of the source range.
   * @param minTarget - The minimum value of the target range.
   * @param maxTarget - The maximum value of the target range.
   * @returns The mapped value in the target range.
   */
  transform(
    value: number | undefined | null,
    minValue: number,
    maxValue: number,
    minTarget: number,
    maxTarget: number,
  ): number {
    // Return minTarget if value is null or undefined
    if (value === null || value === undefined) {
      return minTarget;
    }

    // Prevent division by zero if minValue equals maxValue
    if (minValue === maxValue) {
      throw new Error('Source range cannot have zero length.');
    }

    // Compute normalized ratio of the value in the source range
    const ratio = (value - minValue) / (maxValue - minValue);

    // Map the ratio to the target range
    const transformedValue = ratio * (maxTarget - minTarget) + minTarget;

    return transformedValue;
  }
}
